var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6601 8.4405L19.6801 12.6205C18.8401 16.2305 17.1801 17.6905 14.0601 17.3905C13.5601 17.3505 13.0201 17.2605 12.4401 17.1205L10.7601 16.7205C6.59006 15.7305 5.30006 13.6705 6.28006 9.4905L7.26006 5.3005C7.46006 4.4505 7.70006 3.7105 8.00006 3.1005C9.17006 0.680496 11.1601 0.0304964 14.5001 0.820496L16.1701 1.2105C20.3601 2.1905 21.6401 4.2605 20.6601 8.4405Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.06 17.3896C13.44 17.8096 12.66 18.1596 11.71 18.4696L10.13 18.9896C6.15998 20.2696 4.06997 19.1996 2.77997 15.2296L1.49997 11.2796C0.219975 7.30961 1.27997 5.20961 5.24997 3.92961L6.82997 3.40961C7.23997 3.27961 7.62997 3.16961 7.99997 3.09961C7.69997 3.70961 7.45997 4.44961 7.25997 5.29961L6.27997 9.48961C5.29997 13.6696 6.58998 15.7296 10.76 16.7196L12.44 17.1196C13.02 17.2596 13.56 17.3496 14.06 17.3896Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.49 8.50978C16.43 8.50978 16.37 8.49978 16.3 8.48978L11.45 7.25978C11.05 7.15978 10.81 6.74978 10.91 6.34978C11.01 5.94978 11.42 5.70978 11.82 5.80978L16.67 7.03978C17.07 7.13978 17.31 7.54978 17.21 7.94978C17.13 8.27978 16.82 8.50978 16.49 8.50978Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.56 11.8909C13.5 11.8909 13.44 11.8809 13.37 11.8709L10.46 11.1309C10.06 11.0309 9.82001 10.6209 9.92001 10.2209C10.02 9.82087 10.43 9.58087 10.83 9.68087L13.74 10.4209C14.14 10.5209 14.38 10.9309 14.28 11.3309C14.2 11.6709 13.9 11.8909 13.56 11.8909Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesActive);
export default __webpack_public_path__ + "static/media/notes-active.e43001e4ef67fdc2a6234c88c143a831.svg";
export { ForwardRef as ReactComponent };